/**
 * 用于配置所有的表单外部组件
 */
import moment from "moment";
import selectPersonnel from "../Personnel/components/selectPersonnel";
import selectDepartment from "../Personnel/components/selectDepartment";
import HouseReductionSelect from "./components/HouseReductionSelect";
import ErpRoomUser from "../Common/ErpRoomUser";
import SelectProjectHouse from "./components/SelectProjectHouse";
import SelectExpenseAccount from "./components/SelectExpenseAccount";
import InfoExpenseAccount from "./components/InfoExpenseAccount";
import SelectBudgetItemsByMonth from "./components/SelectBudgetItemsByMonth";
import FlowFormJsExtend from "./config/FlowFormJsExtend";
import FlowFormCssExtend from "./config/FlowFormCssExtend";
import Http from "./common/Http";
import { Decimal } from 'decimal.js'
import SelectFlow from "./components/SelectFlow";
import SelectBank from "./components/SelectBank";
import SelectUsePeriod from "./components/SelectUsePeriod";
import SelectJKD from "./components/SelectJKD";
import UploadFile from "./components/UploadFile";
import SelectSupplier from "./components/SelectSupplier";
import SelectWorkClass from "./components/SelectWorkClass";
import SelectMaterial from "./components/SelectMaterial"
import SelectMaterialBudget from "./components/SelectMaterialBudget"
import SelectYearCode from "./components/SelectYearCode"
import AppConfig from "../../../config/AppConfig";
import ViewFile from "../Common/ViewFile";
import ViewPic from "../Flow/components/plug/ViewPic";
import TravelReimbursement from "../Flow/components/plug/TravelReimbursement";
import RepairsDetail from "../../Admin/App/Repair/RepairsDetail"


export default {
  components:{selectPersonnel,HouseReductionSelect,ErpRoomUser,SelectProjectHouse,selectDepartment,
              SelectExpenseAccount, SelectBudgetItemsByMonth, InfoExpenseAccount, SelectFlow,SelectWorkClass,SelectMaterial,SelectMaterialBudget,ViewFile,
              ViewPic,TravelReimbursement,RepairsDetail,SelectYearCode,SelectSupplier,SelectBank,SelectUsePeriod,UploadFile,SelectJKD
  },
  methods:{
    // 文件预览
    taskView(config,callback){
      console.info(config)
      const that = this;
      that.$refs.ViewFile.show({
              width: config.width,
              height:config.height,
              title:config.file_name,
              src:config.file_url,
              bucket:config.bucket,
              duration_time:86400*3,
              download(){
                // TODO 下载文件逻辑
                // window.open(`${that.host_url}/flow/FlowTaskFile/download?id=${item.id}&login_name=${login_name}&token=${token}`)
                __OSS__.setBucket(config.bucket).setKey(config.file_url).download()
              }
      })
    },
    // 选银行
    SelectBank(config,callback){
      const that = this;
      that.$refs.SelectBank.show(config,callback)
    },
    // 选使用期间
    SelectUsePeriod(config,callback){
      const that = this;
      that.$refs.SelectUsePeriod.show(config,callback)
    },
    // 选借款单
    SelectJKD(config,callback){
      const that = this;
      that.$refs.SelectJKD.show(config,callback)
    },
    // 上传文件
    UploadFile(config,callback){
      const that = this;
      that.$refs.UploadFile.show(config,callback)
    },
    //选人
    selectPersonnel(config,callback){
      const that = this;
      that.$refs.selectPersonnel.show(config,callback)
    },
    // 选供应商
    SelectSupplier(config,callback){
      const that = this;
      that.$refs.SelectSupplier.show(config,callback)
    },
    // 查看投诉单明细
    showRepairsDetail(config){
      const that = this;
      that.$refs.RepairsDetail.show(config)
    },
    //选房产
    SelectProjectHouse(config,callback){
      const that = this;
      that.$refs.SelectProjectHouse.show(config,callback)
    },
    // 选流程
    selectFlow(config,callback) {
      const that = this;
      that.$refs.SelectFlow.show(config,callback)
    },
    // 选班次
    selectWorkClass(config,callback) {
      const that = this;
      that.$refs.SelectWorkClass.show(config,callback)
    },
    //选客户
    ErpRoomUser(house_name,callback){
      const that = this;
      that.$refs.ErpRoomUser.show(house_name,callback)
    },
    //部门
    selectDepartment(config,callback){
      const that = this;
      that.$refs.selectDepartment.show(config,callback)
    },
    selectMaterial(config,callback) {
      const that = this;
      that.$refs.SelectMaterial.show(config,callback)
    },
    selectMaterialBudget(config,callback) {
      const that = this;
      that.$refs.SelectMaterialBudget.show(config,callback)
    },
    selectYearCode(config,callback) {
      const that = this;
      that.$refs.SelectYearCode.show(config,callback)
    },
    openViewPicBox(config,callback) {
      const that = this;
      that.$refs.ViewPic.show(config,callback)
    },
    openTravelReimbursementBox(config,callback) {
      const that = this;
      that.$refs.TravelReimbursement.show(config,callback)
    },
    //拉取js扩展
    getFlowFormJsExtendList(){
      return reJson(FlowFormJsExtend)
    },
    //拉取css扩展
    getFlowFormCssExtendList(){
      return reJson(FlowFormCssExtend)
    },
    //获取时间
    getDateTime(time=new Date(),format='YYYY-MM-DD'){
      return moment(time).format(format);
    },
    // 获取上个月的年月
    getPreYearMonth() {
      let date = new Date();
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let perMonth = month - 1;
      if (month == 1) {
        year = year -1
        perMonth = 12
      }
      if (perMonth < 10) {
        perMonth = '0' + perMonth.toString()
      }
      return {year: year, month: perMonth}
    },
    getNextYearMonth() {
      let date = new Date();
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let perMonth = month + 1;
      if (month == 12) {
        year = year  + 1
        perMonth = 1
      }
      if (perMonth < 10) {
        perMonth = '0' + perMonth.toString()
      }
      return {year: year, month: perMonth}
    },
    //获取用户信息，默认获取个人
    getUserInfo(where={},callback){
      Http.post("/flow/JsApi/getUserInfo",where,callback);
    },
    //请求日生成报表
    getDailyReport(where={},callback){
      const that=this;
      console.log('where',where)
      if (where.payStartDate == null || where.payStartDate == "") {
        that.$Message.error("请选择日期范围");
        return false;
      }
      if (where.payEndDate == null || where.payEndDate == "") {
        that.$Message.error("请选择日期范围");
        return false;
      }
      if (where.pid == "") {
        that.$Message.error("项目参数为空,请选择项目");
        return false;
      }
      if (where.pid == null) {
        that.$Message.error("项目参数失效,请重新选择项目");
        return false;
      }
      if (where.pid >= 10000) {
        that.$Message.error("只能选择一级项目");
        return false;
      }
      if (where.homeName == null || where.homeName == "") {
        that.$Message.error("请选择房产");
        return false;
      }
      ERP.postRequest({url:"admin/ExcelTask/addTask",data:where},ret=>{
        if(ret.code===200){
          that.$message.success("报表生成中……");
          that.__daily_report__=setInterval(function () {
            that.getExcelTask(ret.data.excelTaskId,callback)
          },2000);
        }else {
          that.$message.error("数据拉取失败");
          callback=undefined;
        }
      },err=>{
        callback=undefined;
        that.$message.error("数据请求异常");
      })
    },
    //拉取日报表任务
    getExcelTask(id,callback) {
      const that=this;
      ERP.postRequest({url:"admin/ExcelTask/getExcelTask",data:{id:id}},ret=>{
        if(ret.code&&ret.data){
          if(ret.data.status==1){
            clearInterval(that.__daily_report__);
            callback(AppConfig.erp_server+"/"+ret.data.url)
            that.$message.success("文件生成成功");
          }else if(ret.data.status==3){
            clearInterval(that.__daily_report__);
            that.$message.error("文件生成失败");
          }else {
            callback=undefined;
          }
        }else {
          clearInterval(that.__daily_report__);
          callback=undefined;
          that.$message.error("数据获取失败");
        }
      })
    },
    //获取表单模板列表
    getFormTemplates(where={},callback){
      const that = this;
      Http.get("flow/FlowFormTemplate/getList",{
        where:JSON.stringify(where),
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          typeof callback==="function"&&callback(res.data.list)
        }
      })
    },
    //保存表单模板需要
    saveFormTemplates(data,callback){
      const that = this;
      Http.post("/flow/FlowSheet/uploadBase64", {base64:data.base64},ret=>{
        if(ret.code){
          data.base64=undefined;
          data.image=ret.data
          // f_data.id=undefined;//去了这里就是新增
          Http.get("flow/FlowFormTemplate/save",data,res=>{
            if(res.code) {
              typeof callback==="function"&&callback(res.code)
            }else {
              that.$message.error(ret.msg||'保存失败');
              callback=undefined;
            }
          })
        }else {
          callback=undefined;
          that.$message.error(ret.msg||"图片保存失败")
        }
      })

    },
    // 返回表单数据
    async getFormData() {
      const getData = () => that.$refs.vFormRef.getFormData().then((result) => {
        return result
      })
      let result = await getData()
      return result;
    },
    // 获取选项值列表
    getSystemParamvalueList(param_type_id,callback) {
      let where = {'param_type_id' : param_type_id}
      Http.get("/hrm/SystemParamValue/getParamValueList",where,callback);
    },
    // 获取选项值名称
    getSystemParamvalueName(param_type_id, value,callback) {
      let where = {'param_type_id' : param_type_id, 'value' : value}
      Http.get("/hrm/SystemParamValue/getParamValueName",where,callback);
    },
    // 获取劳务公司列表
    getWorkCompanyList(param, callback) {
      let where = {'page' : 1, 'page_size' : 10000}
      Http.get("/hrm/WorkCompany/list",where,callback);
    },
    getWorkCompanyInfo(id, callback) {
      let where = {'id' : id}
      Http.get("/hrm/WorkCompany/info",where,callback);
    },
    // 获取入职员工信息
    getEntryDetail(user_id, callback) {
      let where = {'user_id' : user_id}
      Http.get("/hrm/PersonnelProcess/getEntryDetail",where,callback);
    },

    /*********************************应收减免***********************************/
    //选减免金额
    HouseReductionSelect(config,callback){
      const that = this;
      that.$refs.HouseReductionSelect.show(config,callback)
    },
    // 选减免后回调
    async HouseReductionSelectAfter(data) {
      const that = this;
      const getData = () => that.$refs.vFormRef.getFormData().then((result) => {
        return result
      })
      let result = await getData()
      result.bpm_ying4_shou1_shu4_jian3_mian3_zi3_biao3_1 = data

      let he2_ji4___jian3_mian3_qian2_jin1_e2 = 0;
      let he2_ji4___jian3_mian3_jin1_e2 = 0;
      let he2_ji4___jian3_mian3_hou4_jin1_e2 = 0;
      // 循环计算
      for(let i=0; i < data.length; i++){
        he2_ji4___jian3_mian3_qian2_jin1_e2 = Decimal(he2_ji4___jian3_mian3_qian2_jin1_e2).add(Decimal(data[i]['jian3_mian3_qian2_jin1_e2'])).toNumber().toFixed(2);
        he2_ji4___jian3_mian3_jin1_e2 = Decimal(he2_ji4___jian3_mian3_jin1_e2).add(Decimal(data[i]['jian3_mian3_jin1_e2'])).toNumber().toFixed(2);
        he2_ji4___jian3_mian3_hou4_jin1_e2 = Decimal(he2_ji4___jian3_mian3_hou4_jin1_e2).add(Decimal(data[i]['jian3_mian3_hou4_jin1_e2'])).toNumber().toFixed(2);
      }

      that.$refs.vFormRef.getWidgetRef("he2_ji4___jian3_mian3_qian2_jin1_e2").setValue(he2_ji4___jian3_mian3_qian2_jin1_e2)
      that.$refs.vFormRef.getWidgetRef("he2_ji4___jian3_mian3_jin1_e2").setValue(he2_ji4___jian3_mian3_jin1_e2)
      that.$refs.vFormRef.getWidgetRef("he2_ji4___jian3_mian3_hou4_jin1_e2").setValue(he2_ji4___jian3_mian3_hou4_jin1_e2)

    },


    //*********************************装修流程***********************************//
    //获取装修审批单数据（在装修管理跳转到流程审批单）
    getFurnishData() {
      // 通过路由获取申请单参数
      let id = this.$route.query.id;
      const that=this;
      let where = {
        id : id,
      }
      ERP.postRequest({url:"admin/CustomerManagement/getFurnish",data:where},ret=>{
        if(ret.code===200){
          that.$message.success("报表生成中……");
          that.__daily_report__=setInterval(function () {
            that.getExcelTask(ret.data.excelTaskId,callback)
          },2000);
        }else {
          that.$message.error("数据拉取失败");
          callback=undefined;
        }
      },err=>{
        callback=undefined;
        that.$message.error("数据请求异常");
      })
    },
    //获取异步对象
    getHttp() {
      return Http
    },

    /***********************************月度计划审批*************************************************/
    getMonthlyPlan(config, callback) {
      let budgetUrl = window.Glob.budget;
      Http.get(budgetUrl + "/admin/budgetSendApi/sendBudgetApply",config,callback)
    },

    /**********************************费用报销审***************************************************/
    selectExpenseAccount(config,callback){
      const that = this;
      config['isPersonal'] = 0;
      let year = that.$refs.vFormRef.getWidgetRef("yu4_suan4_nian2_fen4").getValue()
      let departmentId = that.$refs.vFormRef.getWidgetRef("bu4_men2_id").getValue()
      let level = that.$refs.vFormRef.getWidgetRef("bao4_xiao1_lei4_xing2").getValue()
      if (typeof that.$refs.vFormRef.getWidgetRef("business") != 'undefined') {
        let business = that.$refs.vFormRef.getWidgetRef("business").getValue()
        if (business == '员工报销') {
          config['isPersonal'] = 1;
        } else {
          config['isPersonal'] = 0;
        }
      }

      if (level == '') {
        that.$message.error("请选择报销类型！");
        return;
      }
      if (level == '总部级') {
        level = 1;
      }
      if (level == '分公司级') {
        level = 2;
      }
      if (level == '项目级') {
        level = 3;
      }
      if (level == '总裁办') {
        level = 4;
      }
      config['year'] = year;
      config['departmentId'] = departmentId;
      config['level'] = level;
      that.$refs.SelectExpenseAccount.show(config,callback)
    },

    infoExpenseAccount(config, callback) {
      const that = this;
      let year = that.$refs.vFormRef.getWidgetRef("yu4_suan4_nian2_fen4").getValue()
      let month = __FLOW_PAGE__.getDateTime(new Date(), 'M')
      let departmentId = that.$refs.vFormRef.getWidgetRef("bu4_men2_id").getValue()
      config['year'] = year;
      config['departmentId'] = departmentId;
      config['month'] = month;
      that.$refs.InfoExpenseAccount.show(config,callback)
    },

    /**********************************预算调整审***************************************/
    selectBudgetItemsByMonth(config,callback){
      const that = this;
      let year = __FLOW_PAGE__.getDateTime(new Date(), 'YYYY')
      let BudgetPlanID = that.$refs.vFormRef.getWidgetRef("yu4_suan4_ji4_hua4_id").getValue()
      let level = that.$refs.vFormRef.getWidgetRef("ji2_bie2").getValue()
      if (level == '') {
        that.$message.error("请选择级别！");
        return;
      }
      if (level == '总部级') {
        level = 1;
      }
      if (level == '分公司级') {
        level = 2;
      }
      if (level == '项目级') {
        level = 3;
      }
      config['year'] = year;
      config['BudgetPlanID'] = BudgetPlanID;
      config['level'] = level;
      that.$refs.SelectBudgetItemsByMonth.show(config,callback)
    },
    // 获取预算列表
    getBudgetList(config,callback){
      const that = this;
      let budgetUrl = window.Glob.budget;
      Http.get(budgetUrl + "/admin/budgetSendApi/sendBudgetPlan",config,callback)
    },
    setVFTotal(config) {
      const that = this;
      that.$refs.vFormRef.getWidgetRef("total").setValue(config.total)
      if (parseFloat(config.total) < 0) {
        that.$refs.vFormRef.getWidgetRef('table-cwglzxzj').setHidden(false)
        that.$refs.vFormRef.getWidgetRef('91e051fa-e4f7-46c9-8aca-ce8a24f4e91d').setValue('b88b51a1-4cff-4561-a3ed-9616ee9e7ff2')
      } else {
        // 不走总裁和财务中心
        that.$refs.vFormRef.getWidgetRef('table-cwglzxzj').setHidden(true)
        that.$refs.vFormRef.getWidgetRef('b6798b5b-e6f3-4442-a839-b051c3d5fd1d').setValue('')

        that.$refs.vFormRef.getWidgetRef('91e051fa-e4f7-46c9-8aca-ce8a24f4e91d').setValue('1b86fa5f-374c-4834-8b00-7a016b9bc734')
        that.$refs.vFormRef.getWidgetRef('b976d36e-4436-4e2c-9574-c266d980f4a2').setValue('')
      }
    },
    getFlowYSTZ() {
      const that = this;
      that.$refs.vFormRef.getWidgetRef('91e051fa-e4f7-46c9-8aca-ce8a24f4e91d').getFlow()
    },

    /***********************************400投诉单**************************************/
    // 获取投诉单详情
    getRecordInfo(config,callback){
      let budgetUrl = 'https://quality.gdzawy.com:9001';
      // let budgetUrl = 'http://127.0.0.1:8200';
      Http.get(budgetUrl + "/complaint/ComplaintApi/recordInfo",config,callback)
    },

    viewFile(obj={}){
      let that = this;
      that.$refs.ViewFile.show(obj)
    },
  }
}
const reJson = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}



// WEBPACK FOOTER //
// ./src/components/Admin/Flow/flowFromMixins.js